import { lazy } from 'react';
import { authRoles } from 'app/auth';

const PharmaciesPage = lazy(() => import('./PharmaciesPage'));

const PharmaciesConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'pharmacies',
      element: <PharmaciesPage />,
    },
  ],
};

export default PharmaciesConfig;
